export default function AltPlatformInfo() {
  return (
    <section className="py-5 bg-dark text-light">
      <div className="container">
        {/* Section header */}
        <div className="text-center mb-5 fade-up">
          <h2 className="fw-bold">Why Choose Our Platform</h2>
          <p className="text-light opacity-75 mt-2">
            Built with modern tools to help you grow faster and smarter.
          </p>
        </div>

        {/* Cards */}
        <div className="row g-4">
          {/* Card 1 */}
          <div className="col-12 col-lg-4 fade-up">
            <div className="card h-100 bg-secondary bg-opacity-10 border-0 shadow-sm">
              <div className="card-body text-center">
                <i className="bi bi-lightning-charge fs-1 text-warning mb-3" />
                <h5 className="fw-semibold text-white">Fast & Reliable</h5>
                <p className="text-light opacity-75">
                  Optimized for speed and reliability across all modern devices.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-12 col-lg-4 fade-up delay-1">
            <div className="card h-100 bg-secondary bg-opacity-10 border-0 shadow-sm">
              <div className="card-body text-center">
                <i className="bi bi-shield-lock fs-1 text-info mb-3" />
                <h5 className="fw-semibold text-white">Secure by Design</h5>
                <p className="text-light opacity-75">
                  Security-first architecture to protect users and data.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-12 col-lg-4 fade-up delay-2">
            <div className="card h-100 bg-secondary bg-opacity-10 border-0 shadow-sm">
              <div className="card-body text-center">
                <i className="bi bi-graph-up fs-1 text-success mb-3" />
                <h5 className="fw-semibold text-white">Scalable Growth</h5>
                <p className="text-light opacity-75">
                  Built to scale seamlessly as your platform grows.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
